import { Lot } from '../../../infrastructure/shared/classes/lot';
import { Role } from '../../../identite/shared/classes/role';

export class TypeRendezVous {

    trv_id: string;
    trv_ref: string;
    trv_libelle: string;
    trv_couleur: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.trv_id             = data['trv_id'] ? data['trv_id'] : null;
        this.trv_ref         = data['trv_ref'] ? data['trv_ref'] : null;
        this.trv_libelle          = data['trv_libelle'] ? data['trv_libelle'] : null;
        this.trv_couleur    = data['trv_couleur'] ? data['trv_couleur'] : null;
    }

}
